// Inventory Factory - Dependency Injection

import {InventoryRepositoryImpl} from '../repository/InventoryRepositoryImpl';
import {GetInventoryItemsUseCase} from '../useCases/GetInventoryItemsUseCase';
import {AddStockUseCase} from '../useCases/AddStockUseCase';
import {GetLocationsUseCase} from '../useCases/GetLocationsUseCase';
import {GetInventoryMovementsUseCase} from '../useCases/GetInventoryMovementsUseCase';
import {GetTrackedSerialsUseCase} from '../useCases/GetTrackedSerialsUseCase';
import {GetInventoryStatisticsUseCase} from '../useCases/GetInventoryStatisticsUseCase';
import {GetSerialStatisticsUseCase} from '../useCases/GetSerialStatisticsUseCase';
import {GetComprehensiveReportUseCase} from '../useCases/GetComprehensiveReportUseCase';
import {DeleteSerialUseCase} from '../useCases/DeleteSerialUseCase';
import {GetSerialTimelineUseCase} from '../useCases/GetSerialTimelineUseCase';
import {GetSerialDetailsUseCase} from '../useCases/GetSerialDetailsUseCase';

// Factory class for Inventory feature
export class InventoryFactory {
  private static inventoryRepository: InventoryRepositoryImpl | null = null;

  // Repository Singleton
  private static getInventoryRepository (): InventoryRepositoryImpl {
    if (!this.inventoryRepository) {
      this.inventoryRepository = new InventoryRepositoryImpl();
    }
    return this.inventoryRepository;
  }

  // Use Cases Factory Methods
  static createGetInventoryItemsUseCase (): GetInventoryItemsUseCase {
    const repository = this.getInventoryRepository();
    return new GetInventoryItemsUseCase(repository);
  }

  static createAddStockUseCase (): AddStockUseCase {
    const repository = this.getInventoryRepository();
    return new AddStockUseCase(repository);
  }

  static createGetLocationsUseCase (): GetLocationsUseCase {
    const repository = this.getInventoryRepository();
    return new GetLocationsUseCase(repository);
  }

  static createGetInventoryMovementsUseCase (): GetInventoryMovementsUseCase {
    const repository = this.getInventoryRepository();
    return new GetInventoryMovementsUseCase(repository);
  }

  static createGetTrackedSerialsUseCase (): GetTrackedSerialsUseCase {
    const repository = this.getInventoryRepository();
    return new GetTrackedSerialsUseCase(repository);
  }

  static createDeleteSerialUseCase (): DeleteSerialUseCase {
    const repository = this.getInventoryRepository();
    return new DeleteSerialUseCase(repository);
  }

  static createGetSerialTimelineUseCase (): GetSerialTimelineUseCase {
    const repository = this.getInventoryRepository();
    return new GetSerialTimelineUseCase(repository);
  }

  static createGetSerialDetailsUseCase (): GetSerialDetailsUseCase {
    const repository = this.getInventoryRepository();
    return new GetSerialDetailsUseCase(repository);
  }

  static createGetInventoryStatisticsUseCase (): GetInventoryStatisticsUseCase {
    const repository = this.getInventoryRepository();
    return new GetInventoryStatisticsUseCase(repository);
  }

  static createGetSerialStatisticsUseCase (): GetSerialStatisticsUseCase {
    const repository = this.getInventoryRepository();
    return new GetSerialStatisticsUseCase(repository);
  }

  static createGetComprehensiveReportUseCase (): GetComprehensiveReportUseCase {
    const repository = this.getInventoryRepository();
    return new GetComprehensiveReportUseCase(repository);
  }

  // Reset factory (useful for testing)
  static reset (): void {
    this.inventoryRepository = null;
  }
}
